import uuid from 'uuid/v4';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ResizeAware from 'react-resize-aware';
import { isEqual } from 'lodash';
import DynamicDataGrid from '../common/DynamicDataGrid/DynamicDataGrid';
import GenericButton from '../common/GenericButton';
import DnDItemTypes from '../common/DynamicDnD/DnDItemTypes';
import * as MenuTypesOptions from '../common/MenuTypesOptions';
// import FunctionBox from './FunctionBox/FunctionBox';
import AddToDefinition from '../common/AddToDefinition';
import Modal from '../common/Modal/Modal';
import {
  numberWithCommas,
  checkWeightType,
} from '../../util/CommonUtils';
import * as dictionaryActions from '../../actions/dictionaryActions';
import { GEOGRAPHY_BASES } from '../../actions/actionTypes';

import { ALL, ACTION_TYPE_SCRATCH, DROP_DATAPOINT_TO_SCRATCH, FLEX_STUDY_TAG,
  MOVE_TO_BASE_FROM_SCRATCH,
  MOVE_TO_COLUMN_FROM_SCRATCH, MOVE_TO_ROW_FROM_SCRATCH } from '../../constants';
import { HJ_DICTIONARY_SCRATCH_VPV } from '../../hotjarConstants';
import { getActionName } from '../../util/trackerUtils';
import { getMidpointValue, isNielsenStudyPresent } from '../../util/CrosstabUtils';
import { sendVPVHotjarEvent } from '../../util/hotjarUtils';
import FunctionBox from '../crosstab/FunctionBox/FunctionBox';

const defineModalStyle = {
  width: '50%',
  height: '250px',
  left: '27%',
  top: '30%',
};

const modalStyle = {
  width: '1000px',
  height: '550px',
  left: '13%',
  top: '3%',
};

const addAfterRunCrosstabModalStyle = {
  width: '20%',
  height: 'auto',
  left: '35%',
  top: '20%',
};

const commaFormatter = ({ value }) => <div>{numberWithCommas(value)}</div>;

commaFormatter.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

class Scratch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      crosstabScratch: props.ScratchDataGridData ? props.ScratchDataGridData : [],
      hoverIndex: 0,
    };
    this.handleGridDrop = this.handleGridDrop.bind(this);
    this.scratchDataGrid = React.createRef();
    sendVPVHotjarEvent(HJ_DICTIONARY_SCRATCH_VPV);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.ScratchDataGridData, nextProps.ScratchDataGridData)) {
      if (this.props.ScratchDataGridData && nextProps.ScratchDataGridData
        && (this.props.ScratchDataGridData.length !== nextProps.ScratchDataGridData.length)) {
        setTimeout(() => {
          const wrapper = $('#ScratchDataGrid_gridType');
          wrapper.find('.react-grid-Canvas').scrollTop(wrapper.find('.react-grid-Canvas')[0].scrollHeight);
        }, 300);
      }
      this.setState(() => ({
        crosstabScratch: nextProps.ScratchDataGridData
          ? nextProps.ScratchDataGridData
          : [],
      }));
    } else if (
      this.props.dictionaryTarget !== nextProps.dictionaryTarget &&
      nextProps.dictionaryTarget &&
      nextProps.dictionaryTarget.status === 200 &&
      this.isTargetsDragged
    ) {
      const selectedKeywords = [];
      const selectedNames = [];
      const nielsenPresent = isNielsenStudyPresent(nextProps.dictionaryTarget.data);

      for (const node of nextProps.dictionaryTarget.data) {
        if (nielsenPresent && node.rectype === 'N') {
          selectedKeywords.push(`${node.keyword} >= 1`);
        } else {
          selectedKeywords.push(node.keyword);
        }
        selectedNames.push(node.shortText);
      }
      const titlePrefix = nextProps.dictionaryTarget.useQuestions
        ? `${nextProps.dictionaryTarget.selectedNode.shortText}: `
        : '';
      const sampleWeightedParams = {
        sourceGrid: nextProps.dictionaryTarget.componentGridCategory,
        targetGrid: nextProps.dictionaryTarget.componentGridCategory,
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: this.props.moduleStudy.pn,
        weightType: this.props.moduleWeigthType.wt,
        divisor: this.props.moduleWeigthType.dv,
        expressionList: selectedKeywords,
        // gridData: [...this.tmpData.latestGridEntries],
        selectedNames,
        titlePrefix,
      };
      this.props.moduleAction.getSampleWeighted(sampleWeightedParams);
      this.isTargetsDragged = false;
      // this.tmpData = undefined;
    }
  }

  getGridColumns() {
    const headers = [
      { key: 'title', name: 'Scratch', sortable: true, editable: true, position: 'static' },
    ];
    const weightedHeader = this.props.moduleWeigthType.dv === '100' ? 'Weighted(00)' : 'Weighted(000)';
    if (this.props.moduleStudy &&
      !this.props.moduleStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)) {
      headers.push({
        key: 'sample',
        name: 'Sample',
        sortable: true,
        formatter: commaFormatter,
        position: 'static',
        width: 100,
      });
      headers.push({
        key: 'weighted',
        name: `Weighted ${checkWeightType(this.props.moduleWeigthType)}`,
        sortable: true,
        width: 140,
        formatter: commaFormatter,
        position: 'static',
      });
    }
    return headers;
  }

  hoverHandle = (index, props) => {
    if (this.state.hoverFlag) {
      const hoverIndex = props.idx;
      this.setState({ hoverIndex, hoverFlag: false });
      const { dropItem, dropItemType, componentGridCategory, latestGridEntries,
        } = this.state.dropData;
      if (
        dropItemType === DnDItemTypes.DnD_ITEM_TYPE_4 ||
        dropItemType === DnDItemTypes.DnD_ITEM_TYPE_7
      ) {
        const selectedKeywords = [];
        const selectedNames = [];
        const recTypes = [];
        const dataSmartSearch = [];
        this.callTrackerFn(dropItem.selectedNodes);
        if (dropItemType === DnDItemTypes.DnD_ITEM_TYPE_7) {
          this.callTrackerFn(dropItem.selectedNodes);
          for (const key in dropItem.selectedNodes) {
            dropItem.selectedNodes[key].forEach(data => {
              selectedNames.push(data.name);
              selectedKeywords.push(`${key} ( ${data.nodeId} )`);
              recTypes.push(data.type);
            });
          }
        } else {
          this.callTrackerFn(dropItem.selectedNodes);
          const nielsenPresent = isNielsenStudyPresent(dropItem.selectedNodes);
          for (const node of dropItem.selectedNodes) {
            const tmpDataSmartSearch = {
              expressionFormed: [],
              objectsAdded: [],
              tags: [],
            };
            let keyword = node.keyword;
            if (nielsenPresent && node.rectype === 'N') {
              keyword = `${keyword} >= 1`;
            }
            selectedKeywords.push(node.expression);
            selectedNames.push(node.title);
            tmpDataSmartSearch.expressionFormed.push(node.expression);
            tmpDataSmartSearch.objectsAdded.push(node);
            tmpDataSmartSearch.tags.push(node.title);
            dataSmartSearch.push(tmpDataSmartSearch);
          }
        }

        const sampleWeightedParams = {
          sourceGrid: componentGridCategory,
          targetGrid: componentGridCategory,
          token: this.props.loginResponse.data.token,
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: this.props.moduleStudy.pn,
          weightType: this.props.moduleWeigthType.wt,
          divisor: this.props.moduleWeigthType.dv,
          expressionList: selectedKeywords,
          gridData: latestGridEntries,
          selectedNames,
          recTypes,
        };
        if (this.props.breadcrumbFlag) {
          sampleWeightedParams.objSmartSearchArray = dataSmartSearch;
        }
        this.props.moduleAction.getSampleWeighted(sampleWeightedParams);
      } else {
        this.callTrackerFn(dropItem.selectedEntries);
        const draggedItems = dropItem.selectedEntries.map(selectedEntry => ({
          id: uuid(),
          title: selectedEntry.title,
          originalTitle: selectedEntry.originalTitle,
          sample: selectedEntry.sample,
          weighted: selectedEntry.weighted,
          keyword: selectedEntry.keyword,
          rectype: selectedEntry.rectype || selectedEntry.type,
        }));

        const finalArray = [];

        latestGridEntries.forEach(entries => {
          let duplicateItems = false;
          draggedItems.forEach(items => {
            if (entries.keyword === items.keyword && entries.title === items.title) {
              duplicateItems = true;
            }
          });
          if (!duplicateItems) {
            finalArray.push(entries);
          }
        });
        finalArray.splice(hoverIndex, 0, ...draggedItems);
        finalArray.join();
        this.props.moduleAction.updateSampleWeighted(
          [...finalArray],
          componentGridCategory,
        );
      }
    }
  }

  handleGridDrop = (
    dropItem,
    dropItemType,
    componentGridCategory,
    latestGridEntries,
  ) => {
    setTimeout(() => {
      const wrapper = $(`#${componentGridCategory}_gridType`);
      wrapper.find('.react-grid-Canvas').scrollTop(wrapper.find('.react-grid-Canvas')[0].scrollHeight);
    }, 300);
    if (dropItemType === DnDItemTypes.DnD_ITEM_TYPE_1) {
      this.callTrackerFn(dropItem.selectedNode);
      this.isTargetsDragged = true;
      this.props.dictionaryActions.getDictionaryTargetLoad(
        this.props.loginResponse.data.token,
        this.props.loginResponse.data.uid,
        this.props.activeAccountId,
        this.props.moduleStudy.pn,
        dropItem.selectedNode.node ? dropItem.selectedNode.node : dropItem.selectedNode.recno,
        ALL,
        dropItem.selectedNode,
        dropItem.useQuestions,
        componentGridCategory
      );
    } else if (dropItemType === DnDItemTypes.DnD_ITEM_TYPE_2) {
      const selectedKeywords = [];
      const selectedNames = [];
      const recTypes = [];
      const dataSmartSearch = [];
      const isLabelUpdated = [];
      this.callTrackerFn(dropItem.selectedNodes);
      const nielsenPresent = isNielsenStudyPresent(dropItem.selectedNodes);

      for (const node of dropItem.selectedNodes) {
        const tmpDataSmartSearch = {
          expressionFormed: [],
          objectsAdded: [],
          tags: [],
        };
        let keyword = node.keyword;
        if (nielsenPresent && node.rectype === 'N') {
          keyword = `${keyword} >= 1`;
        }
        selectedKeywords.push(keyword);
        selectedNames.push(node.shortText);
        recTypes.push(node.rectype);
        tmpDataSmartSearch.expressionFormed.push(node.expression || node.keyword);
        tmpDataSmartSearch.objectsAdded.push(node);
        tmpDataSmartSearch.tags.push(node.title || node.shortText);
        dataSmartSearch.push(tmpDataSmartSearch);
        isLabelUpdated.push(node.isLabelUpdated);
      }

      const sampleWeightedParams = {
        sourceGrid: componentGridCategory,
        targetGrid: componentGridCategory,
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: this.props.moduleStudy.pn,
        weightType: this.props.moduleWeigthType.wt,
        divisor: this.props.moduleWeigthType.dv,
        expressionList: selectedKeywords,
        gridData: latestGridEntries,
        selectedNames,
        recTypes,
        isLabelUpdated,
      };
      if (this.props.breadcrumbFlag) {
        sampleWeightedParams.objSmartSearchArray = dataSmartSearch;
      }
      this.props.moduleAction.getSampleWeighted(sampleWeightedParams);
    } else {
      this.setState({
        hoverFlag: true,
        dropData: {
          dropItem,
          dropItemType,
          componentGridCategory,
          latestGridEntries,
        },
      });
    }
  }

  callTrackerFn = attributes => {
    this.props.trackerFn({
      action: DROP_DATAPOINT_TO_SCRATCH,
      attributes: { expression: attributes },
    });
  }

  handleScratchGridSelectionChange = sortDirection => {
    const selectedRows = this.scratchDataGrid
      .current.decoratedRef.current
      .getSelectedEntries();
    let isScratchGridUpBtn = false;
    let isScratchGridDownBtn = false;
    if (
      selectedRows.length === 1 &&
      this.state.crosstabScratch &&
      sortDirection !== 'ASC' &&
      sortDirection !== 'DESC'
    ) {
      if (selectedRows[0].id !== this.state.crosstabScratch[0].id) {
        isScratchGridUpBtn = true;
      }
      if (
        selectedRows[0].id !==
        this.state.crosstabScratch[this.state.crosstabScratch.length - 1].id
      ) {
        isScratchGridDownBtn = true;
      }
    }
    this.setState({ isScratchGridUpBtn, isScratchGridDownBtn });
  };

  handleScratchGridUpDownBtn = posUpdate => {
    // TODO: scrollIntoView or scroll top
    const scratchDataGridObj = this.scratchDataGrid.current.decoratedRef.current;
    const crosstabScratch = [...this.props.ScratchDataGridData];
    const oldIndex = crosstabScratch.findIndex(
      element => element.id === scratchDataGridObj.getSelectedEntries()[0].id,
    );
    const selectedEntry = crosstabScratch.splice(oldIndex, 1)[0];
    crosstabScratch.splice(oldIndex + posUpdate, 0, selectedEntry);
    scratchDataGridObj.storeMovedRowId(selectedEntry.id);
    this.props.moduleAction.updateSampleWeighted(
      crosstabScratch,
      'ScratchDataGrid',
    );
  };

  // Context Menu Handlers
  handleContextMenuOptions = option => {
    const {
      FUNCTIONS,
      ADD_DEFINITION,
      DELETE_SCRATCH,
      SELECT_ALL,
      COPY_TO_COLUMNS,
      COPY_TO_ROWS,
      COPY_TO_BASES,
      MOVE_TO_COLUMNS,
      MOVE_TO_ROWS,
      MOVE_TO_BASES,
    } = MenuTypesOptions.CONTEXT_MENU_OPTIONS;

    const crosstabRows = this.props.RowsDataGridData ? this.props.RowsDataGridData : [];
    const crosstabColumns = this.props.ColumnsDataGridData
      ? this.props.ColumnsDataGridData
      : [];
    const crosstabBases = this.props.BasesDataGridData
      ? this.props.BasesDataGridData
      : [];
    const recycleElements = this.props.recycleElements
      ? this.props.recycleElements
      : [];

    let selectedEntries;

    if (option === FUNCTIONS) {
      selectedEntries = this.scratchDataGrid.current.decoratedRef.current
        .getSelectedEntries()
        .map(selectedEntry => ({
          shortText: selectedEntry.title,
          keyword: selectedEntry.keyword,
          midpoint:
            selectedEntry.dataSmartSearch &&
            selectedEntry.dataSmartSearch.objectsAdded &&
            selectedEntry.dataSmartSearch.objectsAdded[0]
              ? getMidpointValue(
                  selectedEntry.keyword,
                  selectedEntry.dataSmartSearch.objectsAdded
                ).midpoint
              : 0,
            isLabelUpdated: selectedEntry.isLabelUpdated,
        }));
    } else {
      selectedEntries = this.scratchDataGrid.current.decoratedRef.current
        .getSelectedEntries()
        .map(selectedEntry => ({
          id: uuid(),
          title: selectedEntry.title,
          originalTitle: selectedEntry.originalTitle,
          sample: selectedEntry.sample,
          weighted: selectedEntry.weighted,
          keyword: selectedEntry.keyword,
          rectype: selectedEntry.rectype,
          dataSmartSearch: selectedEntry.dataSmartSearch,
          isLabelUpdated: selectedEntry.isLabelUpdated,
        }));
    }

    const action = getActionName(ACTION_TYPE_SCRATCH, option);
    if (selectedEntries.length > 0 && action !== '') {
      this.props.trackerFn({ action, attributes: { expression: selectedEntries } });
      if (action === MOVE_TO_ROW_FROM_SCRATCH || action === MOVE_TO_BASE_FROM_SCRATCH
        || action === MOVE_TO_COLUMN_FROM_SCRATCH) {
        sendVPVHotjarEvent(`${HJ_DICTIONARY_SCRATCH_VPV}/${action}`);
      }
    }

    switch (option) {
      case FUNCTIONS:
        this.setState({ selectedTargets: selectedEntries }, () =>
          this.functionBoxModal.show(),
        );
        break;
      case ADD_DEFINITION:
        this.setState({
          addToDefinition: this.scratchDataGrid
            .current.decoratedRef.current
            .getSelectedEntries()
            .map(({ title, keyword }) => ({
              id: 0,
              name: title,
              expression: keyword,
            })),
        });
        this.addToDefinition.show();
        break;
      case DELETE_SCRATCH:
        this.props.moduleAction.updateSampleWeighted(
          [...selectedEntries, ...recycleElements],
          'RecycleGrid',
        );
        this.props.moduleAction.updateSampleWeighted(
          this.scratchDataGrid
            .current.decoratedRef.current
            .getUnselectedEntries(),
          'ScratchDataGrid',
        );
        break;
      case SELECT_ALL:
        this.scratchDataGrid.current.decoratedRef.current.selectAllEntries();
        break;
      case COPY_TO_COLUMNS:
        this.props.moduleAction.updateSampleWeighted(
          [...crosstabColumns, ...selectedEntries],
          'ColumnsDataGrid',
        );
        break;
      case COPY_TO_ROWS:
        this.props.moduleAction.updateSampleWeighted(
          [...crosstabRows, ...selectedEntries],
          'RowsDataGrid',
        );
        break;
      case COPY_TO_BASES:
        if (!this.props.moduleStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)) {
          this.props.moduleAction.updateSampleWeighted(
            [...crosstabBases, ...selectedEntries],
            'BasesDataGrid',
          );
          break;
        } else if (crosstabBases.length > 0 || selectedEntries.length > 1) {
          this.addAfterRunCrosstabModal.show();
          break;
        } else {
          const isGeographyBase = GEOGRAPHY_BASES.some(base =>
            selectedEntries[0].keyword.includes(base),
          );
          if (isGeographyBase) {
            this.props.moduleAction.updateSampleWeighted(
              [...crosstabBases, ...selectedEntries],
              'BasesDataGrid',
            );
            break;
          } else {
            this.addAfterRunCrosstabModal.show();
            break;
          }
        }
      case MOVE_TO_COLUMNS:
        this.props.moduleAction.updateSampleWeighted(
          [...crosstabColumns, ...selectedEntries],
          'ColumnsDataGrid',
        );
        this.props.moduleAction.updateSampleWeighted(
          this.scratchDataGrid
            .current.decoratedRef.current
            .getUnselectedEntries(),
          'ScratchDataGrid',
        );
        break;
      case MOVE_TO_ROWS:
        this.props.moduleAction.updateSampleWeighted(
          [...crosstabRows, ...selectedEntries],
          'RowsDataGrid',
        );
        this.props.moduleAction.updateSampleWeighted(
          this.scratchDataGrid
            .current.decoratedRef.current
            .getUnselectedEntries(),
          'ScratchDataGrid',
        );
        break;
      case MOVE_TO_BASES:
        if (!this.props.moduleStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)) {
          this.props.moduleAction.updateSampleWeighted(
            [...crosstabBases, ...selectedEntries],
            'BasesDataGrid',
          );
          this.props.moduleAction.updateSampleWeighted(
            this.scratchDataGrid
              .current.decoratedRef.current
              .getUnselectedEntries(),
            'ScratchDataGrid',
          );
          break;
        } else if (crosstabBases.length > 0 || selectedEntries.length > 1) {
          this.addAfterRunCrosstabModal.show();
          break;
        } else {
          const isGeographyBase = GEOGRAPHY_BASES.some(base =>
            selectedEntries[0].keyword.includes(base),
          );
          if (isGeographyBase) {
            this.props.moduleAction.updateSampleWeighted(
              [...crosstabBases, ...selectedEntries],
              'BasesDataGrid',
            );
            this.props.moduleAction.updateSampleWeighted(
              this.scratchDataGrid
                .current.decoratedRef.current
                .getUnselectedEntries(),
              'ScratchDataGrid',
            );
            break;
          } else {
            this.addAfterRunCrosstabModal.show();
            break;
          }
        }
      default:
        return null;
    }
    return null;
  };

  handleCRBGridsResize = dimensions => {
    this.setState({ CRBGridsWidth: dimensions.width });
  };

  updateCrosstabTitleHeader = updatedData => {
    let gridCategory = '';
    let originalList = [];
    let index = 0;
    switch (updatedData.gridCategory) {
      case 'ScratchDataGrid': gridCategory = 'scratch'; break;
      default: gridCategory = '';
    }
    if (gridCategory !== '' && gridCategory === 'scratch') {
      originalList = this.props.ScratchDataGridData;
    }
    if (originalList.length !== 0) {
      index = originalList.findIndex(item => {
        if (item.keyword === updatedData.keyword) {
          return true;
        }
        return false;
      });
      updatedData.index = index;
    }
    this.props.moduleAction.updateCrosstabTitleHeader(updatedData);
  }

  render() {
    return (
      <div>
        <div>
          <div className="position-relative">
            <h5 className="dictionary-grids-header counter-header">
              <span
                className="grid-count left-position-scratch"
                style={{ padding: this.state.crosstabScratch.length < 10 ?
                  '1.5px 3px' : '2px' }}
              >
                {this.state.crosstabScratch.length}
              </span>
            </h5>
            <h5 className="cross-img-container counter-header">
              <button
                className={`cross-img ${
                  this.state.crosstabScratch.length !== 0 ? '' : 'image-disable'
                }`}
                onClick={() =>
                  this.props.moduleAction.clearSampleWeighted(
                    'ScratchDataGrid',
                  )
                }
                disabled={this.state.crosstabScratch.length === 0}
              />
              {this.props.moduleStudy &&
                !this.props.moduleStudy.st.toLowerCase().includes(FLEX_STUDY_TAG) &&
                <button
                  className={`grid-down-arrow-img ${
                    this.state.isScratchGridDownBtn ? '' : 'image-disable'
                  }`}
                  onClick={() => this.handleScratchGridUpDownBtn(1)}
                  disabled={!this.state.isScratchGridDownBtn}
                />
              }
              {this.props.moduleStudy &&
                !this.props.moduleStudy.st.toLowerCase().includes(FLEX_STUDY_TAG) &&
                <button
                  className={`grid-up-arrow-img ${
                    this.state.isScratchGridUpBtn ? '' : 'image-disable'
                  }`}
                  onClick={() => this.handleScratchGridUpDownBtn(-1)}
                  disabled={!this.state.isScratchGridUpBtn}
                />
              }
            </h5>
            <ResizeAware
              style={{ position: 'relative', width: '100%' }}
              onlyEvent
              onResize={this.handleCRBGridsResize}
            >
              <DynamicDataGrid
                ref={this.scratchDataGrid}
                gridCategory="ScratchDataGrid"
                className="columns-data-grid dictionary-data-grid"
                gridHeight={570}
                gridWidth={this.state.CRBGridsWidth}
                headerRowHeight={28}
                rowHeight={27}
                rows={this.state.crosstabScratch}
                columns={this.getGridColumns()}
                menuID={MenuTypesOptions.CONTEXT_MENU_TYPES.SCRATCH}
                handleContextMenuOptions={this.handleContextMenuOptions}
                onGridDrop={this.handleGridDrop}
                rowSelectionType="Multi"
                handleAnswersPreview={this.props.handleAnswersPreview}
                handleRowsSelectionChange={
                  this.handleScratchGridSelectionChange
                }
                onDataUpdate={rows =>
                  this.props.moduleAction.updateSampleWeighted(
                    [...rows],
                    'ScratchDataGrid',
                  )
                }
                isCellSelectable
                minimunRows={20}
                hoverHandle={this.hoverHandle}
                updateCrosstabTitleHeader={this.updateCrosstabTitleHeader}
              />
            </ResizeAware>
          </div>
        </div>
        <Modal
          title="Add to Definition..."
          ref={node => (this.addToDefinition = node)}
          dialogStyles={defineModalStyle}
        >
          <AddToDefinition
            folderName={'Untitled'}
            newExpressions={this.state.addToDefinition}
            handleHide={() => this.addToDefinition.hide()}
            srcScreen={'QuestionsScreen'}
            moduleStudy={this.props.moduleStudy}
          />
        </Modal>
        <Modal
          title="Functions"
          ref={node => (this.functionBoxModal = node)}
          dialogStyles={modalStyle}
        >
          <div className="large-12 columns">
            <div className="column row">
              <FunctionBox
                selectedTargets={this.state.selectedTargets}
                moveAppendToCodingBox={this.props.moveAppendToCodingBox}
                handleParentHide={() => this.functionBoxModal.hide()}
              />
            </div>
          </div>
        </Modal>
        <Modal
          title="Run Crosstab"
          ref={node => (this.addAfterRunCrosstabModal = node)}
          dialogStyles={addAfterRunCrosstabModalStyle}
        >
          <p>Only one geography base can be added.</p>
          <GenericButton
            name="OK"
            btnStyle="button display-block margin-auto"
            onBtnClick={() => this.addAfterRunCrosstabModal.hide()}
          />
        </Modal>
      </div>
    );
  }
}

Scratch.propTypes = {
  handleAnswersPreview: PropTypes.func,
  moveAppendToCodingBox: PropTypes.func,
  ColumnsDataGridData: PropTypes.arrayOf(PropTypes.object),
  RowsDataGridData: PropTypes.arrayOf(PropTypes.object),
  BasesDataGridData: PropTypes.arrayOf(PropTypes.object),
  ScratchDataGridData: PropTypes.arrayOf(PropTypes.object),
  recycleElements: PropTypes.arrayOf(PropTypes.object),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  moduleStudy: PropTypes.shape({
    pn: PropTypes.number,
    dv: PropTypes.number,
    wt: PropTypes.number,
    st: PropTypes.string,
  }),
  dictionaryTarget: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  moduleAction: PropTypes.shape({
    getSampleWeighted: PropTypes.func,
    updateSampleWeighted: PropTypes.func,
    clearSampleWeighted: PropTypes.func,
    updateCrosstabTitleHeader: PropTypes.func,
  }),
  dictionaryActions: PropTypes.shape({
    getDictionaryTargetLoad: PropTypes.func,
  }),
  activeAccountId: PropTypes.number,
  trackerFn: PropTypes.func,
  moduleWeigthType: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
  }),
  breadcrumbFlag: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    dictionaryTarget: state.dictionary.dictionaryTarget,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dictionaryActions: bindActionCreators(dictionaryActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Scratch);
